module.exports = __webpack_public_path__ + "img/hs_tokyo.78301b28.png";